import { Owner, StoreApplicant } from '@funnels/types';

export default function transformApplicantsToEqualOwners(applicants: StoreApplicant[]): Owner[] {
  const [owners, totalPercent] = applicants.reduce(
    ([list, total], a) => {
      const percent = Math.floor(100 / applicants.length) / 100;
      return [
        [
          ...list,
          {
            applicantClientId: a?.clientId ?? '',
            applicantId: a?.id ?? '',
            customerId: a?.customerId ?? '',
            percent,
          },
        ],
        total + percent,
      ];
    },
    [[] as Owner[], 0]
  );

  if (owners.length > 0 && totalPercent !== 1) {
    const remainder = 1 - totalPercent;
    owners[0].percent = owners[0].percent + remainder;
  }
  return owners;
}
